import {
    Component,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from '@angular/core';
import _ from 'lodash';
import { TVMHeadersMeta } from 'src/app/LIVECO.define';
import { TVN } from 'src/app/models/tvn.model';
import { AlertService } from 'src/app/services/alert.service';

@Component({
    selector: 'app-nutritional-table',
    templateUrl: './nutritional-table.component.html',
    styleUrls: ['./nutritional-table.component.scss'],
})
export class NutritionalTableComponent {

    @Input() type: 'intern' | 'extern' | 'modal' = 'extern';

    protected _tvn: TVN = new TVN();
    get tvn(): TVN {
        return this._tvn;
    }
    @Input() set tvn(value: TVN) {
        this._tvn = value;
        this.tvnChange.emit(this._tvn);
    }
    @Output() tvnChange = new EventEmitter<TVN>();

    @Input() last?: TVN;
    @Input() cached?: TVN;

    @Input() readOnly: boolean = false;

    constructor(
        protected s_alert: AlertService,
    ) { }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        const key = event.key;
        const arrowKeys = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
        if (!arrowKeys.includes(key)) return;

        event.preventDefault();
        let row = this.currentRow;
        let col = this.currentCol;

        switch (key) {
            case 'ArrowUp':
                row = row > 0 ? row - 1 : row;
                break;
            case 'ArrowDown':
                row = row < this._tvn.values.length - 1 ? row + 1 : row;
                break;
            case 'ArrowLeft':
                col = col > 0 ? col - 1 : col;
                break;
            case 'ArrowRight':
                col = col < this._tvn.values[0].length - 1 ? col + 1 : col;
                break;
        }

        this.currentRow = row;
        this.currentCol = col;
        this.focusCell(row, col);
    }

    currentRow: number = 0;
    currentCol: number = 0;

    ngOnInit() {
        document.addEventListener('click', this.handleClickEvent.bind(this));
    }

    ngOnDestroy() {
        document.removeEventListener('click', this.handleClickEvent.bind(this));
    }

    handleClickEvent(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const cellClass = target.className.match(/cell-(\d+)-(\d+)/);
        if (cellClass) {
            this.currentRow = parseInt(cellClass[1], 10);
            this.currentCol = parseInt(cellClass[2], 10);
        }
    }

    focusCell(row: number, col: number) {
        const cell = document.querySelectorAll(`.cell-${row}-${col}`)[0];
        if (cell) {
            (cell as HTMLElement).focus();
        }
    }

    getDynamicClasses(rowIndex: number, colIndex: number, inpIndex: number): { [key: string]: boolean; } {
        return {
            ['cell-' + rowIndex + '-' + colIndex]: inpIndex === 0,
            'highlighted': this.isLastDifferent(rowIndex, colIndex),
            'cached-edited': this.isCachedDifferent(rowIndex, colIndex)
        };
    }

    isArray(value: string | string[]): boolean {
        return _.isArray(value);
    }

    hasArray(value: string | string[]): string[] {
        return value as string[];
    }

    getHeaderMeta(i: number) {
        return TVMHeadersMeta[i];
    }

    trackByIndex(index: number, item: any): number {
        return index;
    }

    countDiff(): number {
        if (!this.cached) return 0;
        return this._tvn.countDiff(this.cached);
    }

    isLastDifferent(row: number, col: number): boolean {
        if (!this.last?.values || !_.get(this.last.values, [row, col]) || !_.get(this._tvn.values, [row, col])) return false;
        return _.get(this.last.values, [row, col]) !== _.get(this._tvn.values, [row, col]);
        // if (!this.last) return false;
        // return _.get(this.last.values, [row, col]) !== _.get(this._tvn.values, [row, col]);
    }

    isCachedDifferent(row: number, col: number): boolean {
        if (!this.cached) return false;
        return _.get(this.cached.values, [row, col]) !== _.get(this._tvn.values, [row, col]);
    }

    copyToClipboard(text: string | string[]) {
        if (_.isArray(text)) {
            text = text.join('\n');
        }

        navigator.clipboard.writeText(text).then(() => {
            this.s_alert.success('TEXT.COPIED');
        });
    }

    debug(data: any) {
        console.log(data);
    }
}
